export default "/_next/static/chunks/fonts/AntDesign-163adab9dbd7cb1ed12a03407c74c489.ttf";